import * as React from 'react'

export const ManWithSuccessPrimary = () => {
  return (
    <svg
      width='200'
      height='204'
      viewBox='0 0 200 204'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M30.7521 10.7969H93.6697C99.7071 10.7969 104.627 15.6934 104.627 21.7546V84.6721C104.627 90.7096 99.7309 95.6298 93.6697 95.6298H30.7521C24.6909 95.6061 19.7944 90.7096 19.7944 84.6721V21.7546C19.7944 15.6934 24.6909 10.7969 30.7521 10.7969Z'
        fill='url(#paint0_linear)'
      />
      <path
        d='M125.901 10.7969H189.009C195.065 10.7969 200 15.6934 200 21.7546V84.6721C200 90.7096 195.089 95.6298 189.009 95.6298H125.901C119.845 95.6298 114.91 90.7333 114.91 84.6721V21.7546C114.91 15.6934 119.821 10.7969 125.901 10.7969Z'
        fill='url(#paint1_linear)'
      />
      <path
        d='M30.7521 105.913H93.6697C99.7071 105.913 104.627 110.824 104.627 116.903V180.012C104.627 186.067 99.7309 191.003 93.6697 191.003H30.7521C24.6909 191.003 19.7944 186.067 19.7944 180.012V116.903C19.7944 110.824 24.6909 105.913 30.7521 105.913Z'
        fill='url(#paint2_linear)'
      />
      <path
        d='M125.901 105.913H189.009C195.065 105.913 200 110.824 200 116.903V180.012C200 186.067 195.089 191.003 189.009 191.003H125.901C119.845 191.003 114.91 186.091 114.91 180.012V116.903C114.91 110.824 119.821 105.913 125.901 105.913Z'
        fill='url(#paint3_linear)'
      />
      <path
        d='M102.005 7.96937V186.607C102.005 189.28 99.7172 189.949 97.1208 190.129L6.60668 198.201L5.21851 198.304C2.33933 198.509 0 196.35 0 193.548V4.96166C0.0257069 2.21102 2.26221 -0.0254875 5.01285 0.000219415C5.08997 0.000219415 5.14139 0.000219415 5.21851 0.000219415L7.12082 0.0516333L97.9434 6.99251C100.54 7.06963 102.005 5.29585 102.005 7.96937Z'
        fill='url(#paint4_linear)'
      />
      <path
        d='M104.627 7.96937V186.504C104.627 189.178 102.571 191.517 100 191.697L67.9949 193.959L8.09776 198.201C5.50136 198.432 3.18773 196.53 2.95637 193.933C2.93066 193.779 2.93066 193.599 2.93066 193.445V4.96165C2.93066 2.23672 5.16717 0.000213623 7.8921 0.000213623C7.96922 0.000213623 8.04635 0.000213623 8.12347 0.000213623L43.6762 1.13132L100 2.95651C102.596 3.03363 104.627 5.29584 104.627 7.96937Z'
        fill='url(#paint5_linear)'
      />
      <path
        d='M101.851 17.7894V183.291C101.851 185.784 99.8714 187.969 97.4549 188.124L10.9768 194.036C8.53462 194.268 6.37523 192.442 6.14387 190C6.14387 189.872 6.11816 189.717 6.11816 189.589V15.4758C6.14387 12.9051 8.25184 10.8228 10.8225 10.8228C10.8739 10.8228 10.9254 10.8228 10.9768 10.8228L97.4549 13.1108C99.8714 13.2136 101.851 15.2959 101.851 17.7894Z'
        fill='url(#paint6_linear)'
      />
      <path
        opacity='0.3'
        d='M68.0463 193.959L8.12347 198.201C5.52707 198.432 3.21344 196.53 2.95637 193.933C2.93066 193.779 2.93066 193.625 2.93066 193.445V4.96165C2.93066 2.23672 5.16717 0.000213623 7.8921 0.000213623C7.96922 0.000213623 8.04635 0.000213623 8.12347 0.000213623L43.6762 1.13132C38.4319 25.1159 31.2083 77.0953 58.5605 106.658C86.5039 136.838 88.7661 170.154 68.0463 193.959Z'
        fill='white'
      />
      <path
        d='M81.0541 58.3036C81.0541 73.8048 68.5606 87.1982 53.1107 88.2521C37.6094 89.2804 24.9873 77.4809 24.9873 61.8768C24.9873 46.2727 37.6094 32.8537 53.1107 31.9282C68.5606 30.9771 81.0541 42.8023 81.0541 58.3036Z'
        fill='url(#paint7_linear)'
      />
      <path
        d='M82.5964 58.3036C82.5964 73.8048 70.1028 87.1982 54.6529 88.2521C39.1517 89.2804 26.5295 77.4809 26.5295 61.8768C26.5295 46.2727 39.1517 32.8537 54.6529 31.9282C70.1028 30.9771 82.5964 42.8023 82.5964 58.3036Z'
        fill='url(#paint8_linear)'
      />
      <path
        d='M50.1284 74.1904C49.4858 74.1904 48.8945 73.9334 48.4575 73.4706L37.5835 62.2624C37.4292 62.1082 37.4292 61.8511 37.5835 61.6969L40.3598 58.8177C40.514 58.6635 40.7711 58.6635 40.9254 58.8177L49.82 67.9951C49.9742 68.1493 50.2313 68.1493 50.3855 67.9951L68.7403 49.0491C68.8945 48.8948 69.1516 48.8948 69.3058 49.0491L72.1079 51.9282C72.2621 52.0825 72.2621 52.3395 72.1079 52.4938L51.7737 73.4706C51.3624 73.9334 50.7711 74.1904 50.1284 74.1904Z'
        fill='white'
      />
      <path
        d='M97.0695 80.3087C90.2828 82.3653 81.5939 90.3344 77.0695 94.7303C66.6067 104.833 46.9409 138.895 58.4062 151.054C66.1954 159.332 79.8972 155.861 85.9384 147.507C90.3857 141.363 87.6864 135.784 86.761 124.73C85.707 112.854 89.9743 92.0568 97.0695 80.3087Z'
        fill='url(#paint9_linear)'
      />
      <path
        d='M91.3369 83.5735C86.6582 89.1262 85.013 88.6635 81.3626 96.3241C75.8613 107.841 79.923 121.028 80.4886 135.219C81.1313 150.797 80.4886 179.769 72.6737 194.756C72.5194 194.962 72.468 195.219 72.468 195.45C72.6994 211.337 147.738 200.206 147.609 194.396C147.018 165.604 128.252 102.545 132.905 81.6712C130.797 81.6455 126.633 79.4347 124.936 78.9462C118.201 76.9925 111.131 76.5041 104.19 77.5066C101.671 77.8408 100.411 78.4321 98.5606 79.1262C95.5786 80.3087 93.6505 82.0054 91.3369 83.5735Z'
        fill='url(#paint10_linear)'
      />
      <path
        d='M118.046 61.6455C117.944 66.4784 119.537 73.445 120.154 77.7894C120.771 82.1339 111.928 82.3139 109.023 80.3087C106.376 78.4578 108.381 73.445 110.926 70.8229C113.471 68.2007 115.424 64.319 118.046 61.6455Z'
        fill='url(#paint11_linear)'
      />
      <path
        d='M104.73 60.1288C100.643 56.5298 99.8974 43.7277 104.036 41.2342C106.041 40.0259 109.537 46.3241 111.825 47.5324C114.885 49.1776 123.188 50.9771 124.833 54.2676C126.067 56.7354 123.573 61.8511 122.571 63.702C121.44 65.7843 121.311 65.0645 119.949 66.5298C118.072 68.5863 115.553 70.9514 113.651 73.2393C113.239 71.4912 113.342 71.4912 112.622 69.2547C112.34 68.3807 110.077 64.7303 108.998 63.3421C108.252 62.4424 105.219 60.5658 104.73 60.1288Z'
        fill='url(#paint12_linear)'
      />
      <path
        d='M117.815 70.0774C114.679 72.9822 113.136 76.5298 107.429 75.4501C102.339 74.4989 101.465 61.774 106.118 58.0208C107.661 56.7612 109.923 56.7869 111.851 57.3524C112.982 57.6866 114.165 58.4578 115.321 58.8691C116.375 59.2804 117.249 58.792 118.226 59.846C119.434 61.1828 118.612 64.5761 117.918 66.1956C118.432 65.7329 119.049 65.0902 119.717 64.8588C120.206 64.7046 121.054 63.9077 121.517 64.6018C122.262 65.7329 120.643 67.918 119.692 68.8177C119.229 69.2547 118.355 69.7432 117.815 70.0774Z'
        fill='url(#paint13_linear)'
      />
      <path
        d='M118.561 59.0234C117.867 59.4347 119.101 60.72 118.921 62.0054C118.561 64.4732 117.764 68.9462 114.165 69.3833C112.031 69.6403 109.795 67.738 107.532 67.5067C106.093 67.3524 104.628 67.4552 103.239 67.8151C102.34 70.4887 102.314 74.6789 104.628 76.3241C107.121 78.0979 108.741 77.1725 111.414 76.427C113.188 75.9128 115.142 74.3961 116.247 72.648C117.404 70.8486 118.252 68.9462 119.409 67.0439C120.052 65.9899 120.823 64.6789 121.568 63.5735C121.825 63.2136 122.057 62.8023 122.237 62.391C121.594 61.7997 119.589 58.4578 118.561 59.0234Z'
        fill='url(#paint14_linear)'
      />
      <path
        d='M106.041 69.6403C107.095 70.2316 108.329 70.2316 109.486 70.2316C109.537 70.2316 109.794 70.1288 109.692 70.3344C109.332 71.1056 107.789 71.3884 106.992 71.157C106.427 71.0028 105.501 70.3087 105.579 69.7174C105.63 69.4604 105.938 69.6917 106.041 69.6403Z'
        fill='url(#paint15_linear)'
      />
      <path
        d='M97.9436 175.399C95.9385 173.136 92.7251 169.512 92.5451 164.473C92.0567 151.491 112.134 146.427 111.337 135.887C110.72 127.687 98.432 128.612 91.4397 114.036C90.2315 111.543 85.8356 102.031 89.0233 91.2599C90.0516 87.8151 91.7225 84.6018 93.9333 81.774C93.0593 82.391 92.2367 83.0079 91.3369 83.6249C86.6582 89.1776 85.013 88.7149 81.3626 96.3755C75.8613 107.892 79.923 121.08 80.4886 135.27C81.1313 150.849 80.4886 179.82 72.6737 194.807C72.5194 195.013 72.468 195.27 72.468 195.502C74.2161 211.286 147.738 200.257 147.609 194.448C147.532 190.977 147.198 186.993 146.684 182.674C144.088 183.342 112.339 191.671 97.9436 175.399Z'
        fill='url(#paint16_linear)'
      />
      <path
        d='M76.8639 125.527C72.7508 125.322 75.6042 122.828 74.3446 123.214C73.5734 123.445 54.5246 142.16 60.5143 152.031C66.2469 161.466 90.0001 155.064 98.3806 152.082C103.034 150.412 116.864 145.27 125.27 131.903C126.016 130.694 126.581 129.666 126.967 128.946C108.612 126.53 99.8202 125.964 95.2186 125.939C92.2623 125.913 89.306 126.17 76.8639 125.527Z'
        fill='url(#paint17_linear)'
      />
      <path
        d='M83.8047 123.651C84.3188 127.789 86.4525 140.54 97.2237 151.003C99.3574 153.085 113.908 166.71 134.293 163.291C150.231 160.591 164.396 148.406 167.686 133.162C174.087 103.419 136.067 77.1725 127.352 81.6712C121.491 84.7046 119.82 106.221 128.586 117.095C130.488 119.46 134.036 122.751 133.496 126.864C132.982 130.823 128.972 133.316 126.684 134.679C115.964 141.131 92.545 124.422 86.3497 123.059C85.8869 123.034 85.5528 122.622 83.8047 123.651Z'
        fill='url(#paint18_linear)'
      />
      <path
        d='M140.643 116.941C136.941 113.214 132.674 111.234 127.866 109.743C126.658 109.409 125.45 109.126 124.267 108.818C125.244 111.877 126.658 114.73 128.56 117.095C130.463 119.46 134.01 122.751 133.471 126.864C132.956 130.823 128.946 133.316 126.658 134.679C115.964 141.131 92.545 124.422 86.3497 123.059C85.9127 123.059 85.5785 122.622 83.8047 123.651C83.9846 125.193 84.2674 126.71 84.6016 128.226C93.3934 125.399 102.931 134.242 110.54 138.535C120.309 144.062 132.468 147.635 142.005 140.334C149.152 134.962 146.555 123.085 140.643 116.941Z'
        fill='url(#paint19_linear)'
      />
      <path
        d='M125.27 131.903C125.784 133.111 128.303 134.37 129.511 134.216C131.568 133.985 133.008 132.597 134.267 131.98C135.424 131.44 137.969 130.694 138.123 129.795C138.406 128.072 135.63 127.584 133.984 127.43C131.697 127.198 129.229 127.867 126.966 128.946C126.401 129.949 125.758 130.926 125.27 131.903Z'
        fill='url(#paint20_linear)'
      />
      <path
        d='M80.1028 125.681C88.1233 126.813 89.9742 126.247 90.2056 125.553C90.4884 124.653 88.329 122.828 86.0154 122.52C83.7018 122.211 81.311 123.445 80.1028 125.681Z'
        fill='url(#paint21_linear)'
      />
      <defs>
        <linearGradient
          id='paint0_linear'
          x1='19.7931'
          y1='53.225'
          x2='104.614'
          y2='53.225'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#E7F6FD' />
        </linearGradient>
        <linearGradient
          id='paint1_linear'
          x1='114.909'
          y1='53.225'
          x2='199.986'
          y2='53.225'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#E7F6FD' />
        </linearGradient>
        <linearGradient
          id='paint2_linear'
          x1='19.7931'
          y1='148.469'
          x2='104.614'
          y2='148.469'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#E7F6FD' />
        </linearGradient>
        <linearGradient
          id='paint3_linear'
          x1='114.909'
          y1='148.469'
          x2='199.986'
          y2='148.469'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#E7F6FD' />
        </linearGradient>
        <linearGradient
          id='paint4_linear'
          x1='121.483'
          y1='161.46'
          x2='35.3291'
          y2='87.9667'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D4E5EE' />
          <stop offset='1' stopColor='#BCD6E1' />
        </linearGradient>
        <linearGradient
          id='paint5_linear'
          x1='5.45493'
          y1='98.7886'
          x2='180.668'
          y2='105.305'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D4E5EE' />
          <stop offset='1' stopColor='#BCD6E1' />
        </linearGradient>
        <linearGradient
          id='paint6_linear'
          x1='6.11816'
          y1='102.457'
          x2='101.851'
          y2='102.457'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#E7F6FD' />
        </linearGradient>
        <linearGradient
          id='paint7_linear'
          x1='24.9745'
          y1='60.0901'
          x2='81.049'
          y2='60.0901'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#54A0FC' />
          <stop offset='1' stopColor='#475CA3' />
        </linearGradient>
        <linearGradient
          id='paint8_linear'
          x1='26.5115'
          y1='60.0901'
          x2='82.5887'
          y2='60.0901'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#295DAB' />
          <stop offset='0.62' stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient
          id='paint9_linear'
          x1='126.457'
          y1='167.445'
          x2='66.3535'
          y2='103.689'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#3A3CA6' />
          <stop offset='0.51' stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient
          id='paint10_linear'
          x1='123.49'
          y1='220.605'
          x2='89.2663'
          y2='86.2515'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#475CA3' />
          <stop offset='1' stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient
          id='paint11_linear'
          x1='110.319'
          y1='60.2725'
          x2='123.918'
          y2='110.892'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#893976' />
          <stop offset='1' stopColor='#311944' />
        </linearGradient>
        <linearGradient
          id='paint12_linear'
          x1='115.715'
          y1='64.9847'
          x2='107.404'
          y2='27.2084'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#26264F' />
          <stop offset='1' stopColor='#444B8C' />
        </linearGradient>
        <linearGradient
          id='paint13_linear'
          x1='115.738'
          y1='68.2904'
          x2='73.5219'
          y2='55.2878'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#893976' />
          <stop offset='1' stopColor='#311944' />
        </linearGradient>
        <linearGradient
          id='paint14_linear'
          x1='112.078'
          y1='65.7841'
          x2='103.767'
          y2='28.0077'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#26264F' />
          <stop offset='1' stopColor='#444B8C' />
        </linearGradient>
        <linearGradient
          id='paint15_linear'
          x1='105.373'
          y1='61.6017'
          x2='118.972'
          y2='112.221'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#893976' />
          <stop offset='1' stopColor='#311944' />
        </linearGradient>
        <linearGradient
          id='paint16_linear'
          x1='121.863'
          y1='232.36'
          x2='84.5013'
          y2='100.327'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#475CA3' />
          <stop offset='0.9' stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient
          id='paint17_linear'
          x1='96.1325'
          y1='186.257'
          x2='93.7597'
          y2='147.93'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.03' stopColor='#3A3CA6' />
          <stop offset='0.19' stopColor='#3B41AB' />
          <stop offset='0.41' stopColor='#3F51B8' />
          <stop offset='0.64' stopColor='#466ACE' />
          <stop offset='0.89' stopColor='#4F8DEC' />
          <stop offset='1' stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient
          id='paint18_linear'
          x1='116.278'
          y1='223.645'
          x2='131.272'
          y2='73.4709'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#3A3CA6' />
          <stop offset='0.51' stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient
          id='paint19_linear'
          x1='112.067'
          y1='168.915'
          x2='116.765'
          y2='104.825'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#475CA3' />
          <stop offset='0.9' stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient
          id='paint20_linear'
          x1='133.358'
          y1='114.489'
          x2='130.839'
          y2='139.504'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#893976' />
          <stop offset='1' stopColor='#311944' />
        </linearGradient>
        <linearGradient
          id='paint21_linear'
          x1='86.7626'
          y1='109.797'
          x2='84.2459'
          y2='134.812'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#893976' />
          <stop offset='1' stopColor='#311944' />
        </linearGradient>
      </defs>
    </svg>
  )
}
